import { JSX, createMemo } from 'solid-js';

type Props = {
  value: number | object;
  toDisplay(value: number | object): string;
  class?: string;
  style?: JSX.CSSProperties | string;
};

const FormattedValue = (props: Props): JSX.Element => {
  const formattedValue = createMemo(() => {
    return props.toDisplay(props.value);
  });

  return <p {...(props as Omit<Props, 'toDisplay'>)}>{formattedValue()}</p>;
};

export default FormattedValue;
